import { useQuery } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Fetch compliance matrix with optional filtering
 * Returns loading, error, and data states
 */ export function useComplianceMatrix(projectId, filters) {
    return useQuery({
        queryKey: [
            'complianceMatrix',
            projectId,
            filters
        ],
        queryFn: ()=>proposalProjectApiConnect.getComplianceMatrix(projectId, filters),
        staleTime: 60000,
        enabled: !!projectId,
        retry: 1,
        placeholderData: {
            requirements: [],
            statistics: {
                total: 0,
                addressed: 0,
                partial: 0,
                notAddressed: 0,
                notApplicable: 0,
                complianceScore: 0
            },
            pagination: {
                page: 1,
                limit: 20,
                total: 0,
                pages: 0
            }
        }
    });
}
